import Pusher from "pusher-js";

// Initialize Pusher instance
const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
  cluster: process.env.REACT_APP_PUSHER_CLUSTER,
  forceTLS: true,
});

export default pusher;
